import { AxiosResponse } from 'axios'

export const ARMAZENAR_ERRO_GENERICO = 'ARMAZENAR_ERRO_GENERICO'

export interface ArmazenarErroGenericoAction {
  type: string
  payload: ArmazenarErroGenerico
}

export interface ArmazenarErroGenerico {
  error: AxiosResponse
}
